import { render } from "./SpecialRegionZone.vue?vue&type=template&id=90a13464&scoped=true"
import script from "./SpecialRegionZone.vue?vue&type=script&lang=js"
export * from "./SpecialRegionZone.vue?vue&type=script&lang=js"

import "./SpecialRegionZone.vue?vue&type=style&index=0&id=90a13464&lang=scss&scoped=true"
import "./SpecialRegionZone.vue?vue&type=style&index=1&id=90a13464&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a13464"]])

export default __exports__